<agr-table-v2 *ngIf="isExpanded$ | async" class="element-detail" [dataSource]="dataSource" [withSelection]="false" data-test="silo-product-list_table-v2">
  <ng-container *agrTableTopBar>
    <!-- Intentionally empty to remove the top bar -->
  </ng-container>

  <ng-container *agrTableFiltersWrapper>
    <!-- Intentionally empty to remove the clear filters button -->
  </ng-container>
  <ng-container matColumnDef="deleteFromList">
    <td class="actions spacing--padding-left" mat-cell *matCellDef="let row; let i = index">
      <ng-container *ngIf="quantityForms.at(i) as quantityFormControl">
        <ng-container>
          <button mat-button (click)="deleteSiloProductListItem(row); $event.stopPropagation()">
            <mat-icon class="actions__add-to-cart-icon">delete_outline</mat-icon>
          </button>
        </ng-container>
      </ng-container>
    </td>
  </ng-container>
  <ng-container matColumnDef="name">
    <td mat-cell [attr.aria-label]="'silos.product-list.table-product-name' | translate" *matCellDef="let productItem">
      <span class="silo-product-list__product-column"> {{ productItem.title }}<br /> </span>
      <span class="text--label">
        {{ productItem.externalId }}
      </span>
    </td>
  </ng-container>

  <ng-container matColumnDef="quantity">
    <td mat-cell [attr.aria-label]="'silos.product-list.table-quantity' | translate" *matCellDef="let productItem; let i = index">
      <div *ngIf="quantityForms as formGroup" class="column-quantity">
        <ng-container>
          <mat-form-field
            floatLabel="auto"
            subscriptSizing="dynamic"
            appearance="fill"
            (click)="$event.stopPropagation()"
            class="full-width-field spacing--padding-right mat-form-field__no-spacing column-quantity__form-field"
          >
            <mat-label>{{ 'app.favorites.quantity' | translate }}</mat-label>
            <input
              matInput
              agrNumber
              [step]="productItem.orderingInformation?.increaseOrderUnitQuantity ?? 1"
              [min]="productItem.orderingInformation?.minimumOrderUnitQuantity ?? 0"
              [max]="productItem.orderingInformation?.maximumOrderUnitQuantity"
              [formControl]="$any(formGroup.at(i))"
            />
            <span
              *ngIf="productItem.orderingInformation?.orderUnit"
              matIconSuffix
              data-test="table-desktop__input-number-suffix"
              [attr.data-translate-key]="productItem.orderingInformation?.orderUnit"
            >
              {{ 'unit.' + productItem.orderingInformation.orderUnit | translate }}
            </span>
          </mat-form-field>
        </ng-container>
      </div>
    </td>
  </ng-container>
  <ng-container matColumnDef="remainderSilo">
    <td
      mat-cell
      [attr.aria-label]="'product.wizard.silo.remainder-silo' | translate"
      *matCellDef="let productItem; let i = index"
      class="spacing--padding-half-vertical"
    >
      <div class="column-remainder-silo">
        <mat-form-field subscriptSizing="dynamic">
          <mat-label class="remainder-silo-label">{{ 'product.wizard.silo.remainder-silo' | translate }}</mat-label>
          <mat-select [formControl]="remainderSiloForms.at(i)">
            <mat-option>-</mat-option>
            <ng-container *ngIf="availableRestSilos$ | async as restSilos; else noRestSilosAvailable">
              <mat-option *ngFor="let silo of restSilos" [value]="silo">{{ silo | formatSiloTitle }}</mat-option>
            </ng-container>
            <ng-template #noRestSilosAvailable>
              <mat-option>
                {{ 'product.wizard.silo.no-silos-available' | translate }}
              </mat-option>
            </ng-template>
          </mat-select>
        </mat-form-field>
      </div>
    </td>
  </ng-container>
  <ng-container matColumnDef="supplements">
    <td mat-cell [attr.aria-label]="'silos.product-list.table-supplements' | translate" *matCellDef="let productItem; let i = index">
      <ng-container *ngIf="quantityForms as formGroup">
        <div *ngIf="productItem.skuHasSupplements; else noSupplements" class="column-product-supplements flex--row">
          <!-- Add/Modify button -->
          <div class="column-product-supplements__button-container">
            <button mat-button class="button--text" (click)="openProductSupplementDialog(siloId, productItem); $event.stopPropagation()">
              <mat-icon> {{ productItem.supplements?.length ? 'edit' : 'add' }}</mat-icon>
              <span *ngIf="!productItem.supplements?.length">
                {{ 'cart.supplement.add-product-supplement' | translate }}
              </span>
            </button>
          </div>

          <!-- Product additives -->
          <div *ngIf="productItem.supplements.length" class="supplement-information-wrapper">
            <div *ngFor="let supplement of productItem.supplements" class="supplement-information">
              <div class="supplement-description">{{ supplement?.description }}</div>
              <div class="supplement-quantity">
                {{ (supplement?.quantity / 100) * $any(formGroup.at(i)).value | agrNumber }}
                {{ 'unit.' + productItem.orderingInformation?.orderUnit | translate }}
                ({{ supplement?.quantity | agrNumber }}%)
              </div>
            </div>
          </div>
        </div>
      </ng-container>
      <ng-template #noSupplements>-</ng-template>
    </td>
  </ng-container>
  <ng-container matColumnDef="deliveryInformation">
    <td mat-cell [attr.aria-label]="'silos.product-list.table-delivery-date' | translate" *matCellDef="let row; let i = index" class="spacing--padding-left">
      <ng-container *ngIf="row.isUserAllowedToOrderItem">
        <div *ngIf="deliveryInformationForms.at(i) as deliveryInformationFormControl">
          <div>
            <button mat-button (click)="openDeliveryDateDialog(row, deliveryInformationFormControl)">
              <ng-container *ngIf="!deliveryInformationFormControl.value?.deliveryDate; else editDeliveryDate">
                <mat-icon>add</mat-icon>
              </ng-container>
              <ng-template #editDeliveryDate>
                <mat-icon>edit</mat-icon>
                <span>{{ deliveryInformationFormControl.value.deliveryDate | agrDate }}</span>
              </ng-template>
            </button>
          </div>
          <div class="text--label" *ngIf="deliveryInformationFormControl.value | formatFlexibilityDate as minimumDate">
            {{ minimumDate }} -
            {{ deliveryInformationFormControl.value.deliveryDate | agrDate }}
          </div>
        </div>
      </ng-container>
    </td>
  </ng-container>
  <ng-container matColumnDef="lineActions">
    <td class="actions spacing--padding-left" mat-cell *matCellDef="let row; let i = index">
      <ng-container *ngIf="quantityForms.at(i) as quantityFormControl">
        <div class="actions-buttons">
          <button mat-button class="delete-single-item-button__mobile" (click)="deleteSiloProductListItem(row); $event.stopPropagation()">
            <mat-icon class="actions__add-to-cart-icon">delete_outline</mat-icon>
          </button>
          <button
            class="actions__add-button"
            color="primary"
            mat-flat-button
            [disabled]="quantityFormControl.invalid || !row.isUserAllowedToOrderItem"
            (click)="addToCart(row, i)"
          >
            <mat-icon class="actions__add-to-cart-icon">add_shopping_cart</mat-icon>
          </button>
        </div>
      </ng-container>
    </td>
  </ng-container>

  <tr class="silo-product-list" mat-row *matRowDef="let _; columns: tableColumns"></tr>
  <tr *matNoDataRow class="silo-product-list fixed-height">
    <td class="text--center" [attr.colspan]="tableColumns.length">
      <span class="silo-empty-message">{{ 'silos.emptyProductList' | translate }}</span>
    </td>
  </tr>
</agr-table-v2>
